import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Switch, Select, Alert, Tooltip } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import './Cleanup.scss';

function Cleanup({
  form,
  archiveLogsPath,
}: {
  form: any;
  archiveLogsPath: string;
}) {
  const intl = useIntl();
  return (
    <section className="config-form__cleanup">
      <div className="config-form__border-bottom config-form__section-switch">
        <span className="config-form__section-headers-titles">
          <FormattedMessage id="settings.cleanup" />
          <Tooltip
            title={intl.formatMessage(
              { id: 'settings.cleanupInfo' },
              { archiveLogsPath }
            )}
          >
            <InfoCircleOutlined />
          </Tooltip>
        </span>
        <Form.Item
          name="cleanupEnabled"
          valuePropName="checked"
          className="cleanup__switch-item"
        >
          <Switch defaultChecked={true} />
        </Form.Item>
      </div>
      <Form.Item
        noStyle
        shouldUpdate={(prev, curr) => prev.cleanupEnabled !== curr.cleanupEnabled}
      >
        {({ getFieldValue }) => {
          const disabled = !getFieldValue('cleanupEnabled');
          return (
            <>
              {disabled ? (
                <Alert
                  type="warning"
                  showIcon
                  style={{ marginBottom: 16 }}
                  message={intl.formatMessage({ id: 'settings.cleanupWarning' })}
                />
              ) : null}
              <div className="cleanup__fields">
                <Form.Item
                  name="cleanupFrequency"
                  label={<FormattedMessage id="settings.cleanupFrequency" />}
                >
                  <Select disabled={disabled}>
                    <Select.Option value="daily">
                      {intl.formatMessage({ id: 'settings.cleanupFrequency.daily' })}
                    </Select.Option>
                    <Select.Option value="weekly">
                      {intl.formatMessage({ id: 'settings.cleanupFrequency.weekly' })}
                    </Select.Option>
                    <Select.Option value="monthly">
                      {intl.formatMessage({ id: 'settings.cleanupFrequency.monthly' })}
                    </Select.Option>
                    <Select.Option value="6months">
                      {intl.formatMessage({ id: 'settings.cleanupFrequency.6months' })}
                    </Select.Option>
                  </Select>
                </Form.Item>
              </div>
            </>
          );
        }}
      </Form.Item>
    </section>
  );
}

export default Cleanup;